export enum FileDisplayType {
  PDF = 'PDF',
  SVG = 'SVG',
  IMAGE = 'IMAGE',
  XLSX = 'XLSX',
  TEXT = 'TEXT',
}
